var React = require('react');

function LogOut (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5"},React.createElement("path",{"d":"M6.667 16H3.556C2.696 16 2 15.304 2 14.444V3.556C2 2.696 2.696 2 3.556 2h3.11M12.111 12.889L16 9l-3.889-3.889M16 9H6.667"})));
}

LogOut.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = LogOut;

LogOut.default = LogOut;
